import React, { Component } from "react";
import { Button } from "reactstrap";
import { arrayMove } from "react-sortable-hoc";
import AddItem from "./AddItem";
import AddGroup from "./AddGroup";
import SortableList from "./SortableList";

class PriceList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: props.data,
    };
  }

  addItem = (price) => {
    const { items } = this.state;
    this.setState({
      items: [...items, price],
    });
  };

  deleteItem = (index) => {
    let items = this.state.items.slice();
    items.splice(index, 1);
    this.setState({
      items: items,
    });
  };

  onSortEnd = ({ oldIndex, newIndex }) => {
    const { items } = this.state;

    this.setState({
      items: arrayMove(items, oldIndex, newIndex),
    });
  };

  componentWillUpdate(nextProps, nexState) {
    /*    if (this.state.items !== nexState.items) {
      console.log('in');
      this.props.onPricesChange({
        prop: 'prices',
        value: nexState.items
      });
    } */
  }

  handleSave = () => {
    const { onSave } = this.props;
    const { items } = this.state;
    onSave(items);
  };

  render() {
    const { items } = this.state;

    console.log(items);

    return (
      <div>
        <AddGroup handleChange={this.addItem} />
        <AddItem handleChange={this.addItem} />
        <SortableList
          items={items}
          onSortEnd={this.onSortEnd}
          useDragHandle={true}
          onDelete={this.deleteItem}
        />
        <div style={{ marginTop: "10px" }}>
          <Button onClick={this.handleSave}>Uložit</Button>
        </div>
      </div>
    );
  }
}

export default PriceList;



// WEBPACK FOOTER //
// ./src/modules/Pricing/PriceList/index.js